import { createAction, handleActions } from "redux-actions";

const SET = 'questionView.SET';
const CORRECT_ANSWER_SET = 'questionView.CORRECT_ANSWER_SET';
const CLEAR = 'questionView.CLEAR';

const defaultState = {
  scale : 1,
  size : [],
  isShowTip : false,
  isCorrectAnswer: false,
  tooltipStatus : 1,
  scribbleTooltipStatus : 0,
  isScribble : false,
  isErase: false,
  scribbleCanvasDraw : null,
  PV_CONT : null
};

const setQuestionViewAction = createAction( SET, payload => payload );
const setCorrectAnswerAction = createAction(CORRECT_ANSWER_SET, payload => payload );
const clearQuestionViewAction = createAction( CLEAR );

const questionView = handleActions( {
  [ SET ] : ( state, action ) => ({ ...state, ...action.payload }),
  [CORRECT_ANSWER_SET]: (state, action) => {
    return ({ ...state, ...action.payload })
  },
  [ CLEAR ] : () => defaultState
}, defaultState );

export default questionView;
export { setQuestionViewAction, setCorrectAnswerAction, clearQuestionViewAction };
